'use strict';

(function() {
  const SCROLL_THRESHOLD = 10;
  let lastScrollY = 0;
  let ticking = false;
  let navElement = null;

  function onScroll() {
    if (!navElement) return;

    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;

    // ページ上部付近では常に表示
    if (currentScrollY <= 50) {
      navElement.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      return;
    }

    // しきい値未満の微小スクロールは無視
    if (Math.abs(delta) < SCROLL_THRESHOLD) return;

    if (delta > 0) {
      // 下スクロール → 非表示
      navElement.classList.add('is-hidden');
    } else {
      // 上スクロール → 表示
      navElement.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  }

  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  function init() {
    navElement = document.querySelector('.mobile-nav');
    if (!navElement) return;

    lastScrollY = window.scrollY;

    // ブラウザバック等でページ中間にスクロール復元された場合、
    // ナビを非表示状態で初期化（ページ上部付近なら表示）
    if (lastScrollY > 50) {
      navElement.classList.add('is-hidden');
    } else {
      navElement.classList.remove('is-hidden');
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  function cleanup() {
    if (navElement) {
      navElement.classList.remove('is-hidden');
    }
    window.removeEventListener('scroll', handleScroll);
    navElement = null;
    ticking = false;
    lastScrollY = 0;
  }

  document.addEventListener('turbolinks:load', init);
  document.addEventListener('turbolinks:before-cache', cleanup);
})();
